<script>
import ProInput from '$common/ProInput'
export default {
  name: 'GiftCard',
  components: {
    'pro-input': ProInput,
  },
  props: {
    options: {
      required: true,
    },
  },
  data () {
    return {
      card: null,
      stripe: null,
      cardReady: false,
      isLoading: false,
      giftCardPrice: this.options.giftCardPrice,
      sendToRecipient: false,
      purchaseComplete: false,
      form: {
        numberOfVouchers: 1,
        buyer: {
          fname: '',
          lname: '',
          email: '',
        },
        recipient: {
          fname: '',
          lname: '',
          email: '',
        }, 
      },
      formOptions: {
        numberOfVouchers: {
          title: 'How many gift cards would you like to buy?',
          type: 'number',
          errorIf: (val) => val >= 1 ? '' : 'You must order at least 1 gift card',
        },
        buyer: {
          fname: {
            title: 'Your First Name',
            errorIf: (val) => val ? '' : 'Enter your first name',
          },
          lname: {
            title: 'Your Last Name',
            errorIf: (val) => val ? '' : 'Enter your last name',
          },
          email: {
            title: 'Your Email',
            errorIf: (val) => this.$regex.is(val).a('email') ? '' : 'Enter your valid email',
          }
        },
        recipient: {
          fname: {
            title: 'Recipient\'s First Name',
            errorIf: (val) => val ? '' : 'Enter recipient\'s first name',
          },
          lname: {
            title: 'Recipient\'s Last Name',
            errorIf: (val) => val ? '' : 'Enter recipient\'s last name',
          },
          email: {
            title: 'Recipient\'s Email',
            errorIf: (val) => {
              if (val && (val.charAt(0) == ' ' || val.charAt(val.length - 1) == ' ')) return 'Remove spaces from before or after email'
              return this.$regex.is(val).a('email') ? '' : 'Enter recipient\'s valid email'
            },
          }
        },
      },
    }
  },
  methods: {
    async onSubmit() {
      const errors = await this.getErrors()
      if (errors.length) return errors.forEach(err => this.$toast({copy: err, class: 'alert'}))

      this.isLoading = true
      // validate card
      let card
      try {
        card = (await this.stripe.createToken(this.card)).token
      } catch (e) {
        this.$toast({
          copy: 'Problem with card',
          class: 'alert',
        })
        this.isLoading = false
        return console.log(e)
      }

      // TODO create the function for buying a gift card
      try {
        await this.$HTTP({
          method: 'post',
          uri: `anonymous/purchase-gift-card`,
          body: {
            buyer: this.form.buyer,
            recipient: this.form.recipient,
            card,
            origin: location.origin,
            purchaseDetails: {
              vouchers: this.form.numberOfVouchers,
              sendToRecipient: this.sendToRecipient,
              amount: this.totalPrice,
            }
          },
          secure: false,
        })
      } catch (e) {
        console.error(e)
        this.$toast({
          copy: e.body.message,
          class: 'alert'
        })
        this.isLoading = false
        return
      }

      this.isLoading = false
      this.$toast({copy: 'Thank you for your order!'})
      this.purchaseComplete = true
      // this.$modals.hide('gift-card')
      
    },
    getErrors () {
      return new Promise(async (resolve, reject) => {
        // for the standard entities like guardian and application
        const checkErrorIfs = (type) => Object.keys(this.form[type])
          //.map(key => {console.log(key);return this.formOptions[type][key].errorIf(this.form[type][key])})
          .map(key => this.formOptions[type][key].errorIf(this.form[type][key]))
          .filter(Boolean)

        const buyerErrors = checkErrorIfs('buyer')
        const recipientErrors = this.sendToRecipient ? checkErrorIfs('recipient') : []
        const purchaseErrors = this.formOptions.numberOfVouchers.errorIf(this.form.numberOfVouchers)
        const cardError = this.cardReady ? [] : ['Complete card input']

        resolve([
          ...buyerErrors,
          ...recipientErrors,
          ...purchaseErrors,
          ...cardError,
        ])
      })
    },
    setUpStripeElement () {
      // eslint-disable-next-line
      this.stripe = Stripe(process.env.VUE_APP_STRIPE_KEY)
      const elements = this.stripe.elements()

      this.card = elements.create('card')

      this.card.on('change', (event) => {
        this.cardReady = event.complete
      })

      this.card.mount('#card-element')
    },
  },
  computed: {
    totalPrice () {
      return Math.floor(this.form.numberOfVouchers*this.giftCardPrice/100)*100
    },
  },
  mounted () {
    this.setUpStripeElement()
  },
}
</script>

<template lang="pug">
  #gift-card-main.modal-main
    .gift-card-container.modal-container(
      v-if='!purchaseComplete'
    )
      .title Order Gift Card
      .content
        .description The purchase of 1 gift card purchases 1 seat for access to a 4-week long coding cohort in a virtual Code School class.
      .content.form-holder
        .pro-form
          .form-row
            pro-input(
              :options='formOptions.numberOfVouchers',
              v-model='form.numberOfVouchers'
            )
          .row-title Enter your information here so we can send you a receipt.
          .form-row(
            v-for='(options, key) in formOptions.buyer'
          )
            pro-input(
              :options='options'
              v-model='form.buyer[key]'
            )
          .form-row 
            pro-input(
              :options='{type: "checkbox", prompt: "Want us to send the gift card for you?"}'
              v-model='sendToRecipient'
            )
          template(
            v-if='sendToRecipient'
          )
            .row-title Enter the recipient's information here and we'll send them the gift card.
            .form-row(
              v-for='(options, key) in formOptions.recipient'
            )
              pro-input(
                :options='options'
                v-model='form.recipient[key]'
              )
      .total-row
        .total Total: ${{totalPrice > 0 ? totalPrice : 0}}
      .content.payment
        .content-title Credit card
        .explain
          | Enter the information for the credit card you'd like to use to pay for this gift card.
        .card-holder
          #card-element
      .action
        .button.minor(
          @click='$modals.hide(`gift-card`)'
        ) Cancel
        span
        .button.major(
          v-if='isLoading'
        ) 
          i.material-icons.spin-me refresh
        .button.major(
          v-else
          @click='onSubmit'
        ) Buy Gift Card
    .gift-card-container.modal-container(
      v-else
    )
      .title Purchase Complete!
      .content
        .description Thank you for your purchase. We'll send an email to {{form.buyer.email}} soon with your gift card!
      .action
        .button.minor(
          @click='$modals.hide("gift-card")'
        ) Close
</template>

<style lang="sass" scoped>
.gift-card-container
  .content
    .description
      .message
        margin-top: 0.5rem
  .form-holder
    .row-title
      margin-bottom: 1rem
  .total-row
    text-align: center
    font-size: 1.5em
    font-weight: 600
  .payment
    .explain
      margin-bottom: 1rem
</style>